<!--===============================
=            STERPPERS            =
================================-->


<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Sterppers</div>
      </base-header>
    </v-row>
    <v-row>
      
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Steppers
          </div>
          <div slot="card-subheader">A stepper can be used for a multitude of scenarios, including shopping carts,
            record creation and more.</div>
          <div slot="card-body">

            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">
                  Name of step 1
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" step="2">
                  Name of step 2
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">
                  Name of step 3
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="mb-12" color="grey lighten-1" height="90px"></v-card>

                  <v-btn color="primary" class="white--text" @click="e1 = 2">
                    Continue
                  </v-btn>

                  <v-btn text>
                    Cancel
                  </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card class="mb-12" color="grey lighten-1" height="90px"></v-card>

                  <v-btn color="primary" class="white--text" @click="e1 = 3">
                    Continue
                  </v-btn>

                  <v-btn text>
                    Cancel
                  </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card class="mb-12" color="grey lighten-1" height="90px"></v-card>

                  <v-btn color="primary" class="white--text" dark @click="e1 = 1">
                    Continue
                  </v-btn>

                  <v-btn dark text>
                    Cancel
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">

        <base-card>
          <div slot="card-header">
            #Alternate label

          </div>
          <div slot="card-subheader">Steppers also have an alternative label style which places the title under the step
            itself.</div>
          <div slot="card-body">

            <div>
              <v-stepper alt-labels>
                <v-stepper-header>
                  <v-stepper-step step="1">
                    Ad unit details
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Ad sizes
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">
                    Ad templates
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper alt-labels class="mt-15">
                <v-stepper-header>
                  <v-stepper-step step="1">
                    Ad unit details
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Ad sizes
                    <small>Optional</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">
                    Ad templates
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">

            Non linear
          </div>
          <div slot="card-subheader">Non-linear steppers allow the user to move through your process in whatever way
            they choose.</div>
          <div slot="card-body">

            <div>
              <v-stepper non-linear>
                <v-stepper-header>
                  <v-stepper-step editable step="1">
                    Select campaign settings
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step editable step="2">
                    Create an ad group
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3" editable>
                    Create an ad
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper class="mt-5" non-linear>
                <v-stepper-header>
                  <v-stepper-step complete editable step="1">
                    Select campaign settings
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step editable step="2">
                    Create an ad group
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="3">
                    Create an ad
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper class="mt-8" non-linear value="3">
                <v-stepper-header>
                  <v-stepper-step complete editable step="1">
                    Select campaign settings
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="2">
                    Create an ad group
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="3">
                    Create an ad
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>

    
     
      <v-col class="col-12 col-md-12 col-sm-12">

        <base-card>
          <div slot="card-header">
            #Vertical errors
          </div>
          <div slot="card-subheader">The same state also applies to Vertical steppers.

          </div>
          <div slot="card-body">

            <v-stepper v-model="e13" vertical>
              <v-stepper-step step="1" complete>
                Name of step 1
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-card color="grey lighten-1" class="mb-5" height="50px"></v-card>
                <v-btn color="primary" class="white--text" @click="e13 = 2">
                  Continue
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-stepper-content>

              <v-stepper-step step="2" complete>
                Name of step 2
              </v-stepper-step>

              <v-stepper-content step="2">
                <v-card color="grey lighten-1" class="mb-5" height="50px"></v-card>
                <v-btn color="primary" class="white--text" @click="e13 = 3">
                  Continue
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :rules="[() => false]" step="3">
                Ad templates
                <small>Alert message</small>
              </v-stepper-step>

              <v-stepper-content step="3">
                <v-card color="grey lighten-1" class="mb-5" height="50px"></v-card>
                <v-btn color="primary" @click="e13 = 4">
                  Continue
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-stepper-content>

              <v-stepper-step step="4">
                View setup instructions
              </v-stepper-step>

              <v-stepper-content step="4">
                <v-card color="grey lighten-1" class="mb-12" height="90px"></v-card>
                <v-btn color="primary" @click="e13 = 1">
                  Continue
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-stepper-content>
            </v-stepper>

          </div>
        </base-card>

      </v-col>
      </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },data() {
      return {
        e1: 1,
        e6: 1,
        steps: 2,
        e13: 1,
      }
    },
    watch: {
      steps(val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
    },

    methods: {
      nextStep(n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
    },
    
  }
</script>
<!--====  End of STERPPERS  ====-->
